const defaultMapFunction = data => ({ value: data, label: data });

export default {
  make(dataArray, mapFunction) {
    return Object.freeze(dataArray.map(
      // Use the default map function if no mapFunction is provided
      (typeof mapFunction === 'function') ? mapFunction : defaultMapFunction
    ));
  },
};



// WEBPACK FOOTER //
// ./src/utils/selectorDataMaker.js